import { GetterTree } from 'vuex';
import RootState from '@/store/root_state';
import { StudyPlanningState } from './state';
import { StudyPlanningModel } from '@/models/studyPlanning/StudyPlanningModel';
import { WeekModel } from '@/models/studyPlanning/WeekModel';
import { ListModel } from '@/models/studyPlanning/ListModel';
import { StudyPlanningBreakpointModel } from '@/models/studyPlanning/StudyPlanningBreakpointModel';
import { StudyPlanningChimeraContractModel } from '@/models/studyPlanning/StudyPlanningContractModel';

const getters: GetterTree<StudyPlanningState, RootState> = {
  studyPlanning: (state, studyPlanningGetters) => (courseId: number) => {
    if (!state.studyPlanning || state.studyPlanning.courseId !== courseId) return null;

    return new StudyPlanningModel(state.studyPlanning, studyPlanningGetters);
  },
  studyPlanningWeek: (state, studyPlanningGetters) => {
    return state.currentWeek && new WeekModel(state.currentWeek, studyPlanningGetters);
  },
  studyPlanningAnticipatedWeeks: (state, studyPlanningGetters) => (studyPlanningId: number) => {
    return Object.values(state.anticipatedWeeks)
      .filter((w) => w.studyPlanningId === studyPlanningId)
      .map((w) => new WeekModel(w, studyPlanningGetters));
  },
  studyPlanningAnticipatedWeekById: (state, studyPlanningGetters) => (weekId: number) => {
    const anticipatedWeek = state.anticipatedWeeks[weekId];

    return anticipatedWeek ? new WeekModel(anticipatedWeek, studyPlanningGetters) : null;
  },
  studyPlanningWeekLists: (state, studyPlanningGetters) => {
    if (!state.weekLists) {
      return [];
    }

    return state.weekLists.map((list) => new ListModel(list, studyPlanningGetters));
  },
  studyPlanningAnticipatedWeekListsByWeekId:
    (state, studyPlanningGetters) => (weekId: number | string) => {
      return (
        state.anticipatedWeeksListsByWeekId[weekId]?.map(
          (l) => new ListModel(l, studyPlanningGetters),
        ) ?? []
      );
    },
  studyPlanningBreakpoints: (state, studyPlanningGetters) => {
    return Object.values(state.breakpoints)
      .sort((a, b) => a.numberOfMonths - b.numberOfMonths)
      .map((breakpoint) => new StudyPlanningBreakpointModel(breakpoint, studyPlanningGetters));
  },
  studyPlanningExtensionBreakpoints: (state, studyPlanningGetters) => {
    return Object.values(state.extensionBreakpoints)
      .sort((a, b) => a.numberOfMonths - b.numberOfMonths)
      .map((breakpoint) => new StudyPlanningBreakpointModel(breakpoint, studyPlanningGetters));
  },
  chimeraCourseContract: (state, studyPlanningGetters) => {
    return (
      state.chimeraContract &&
      new StudyPlanningChimeraContractModel(state.chimeraContract, studyPlanningGetters)
    );
  },
};

export default getters;
